import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";

import { FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHAreaUpd } from "services/services-mia/programa-salud/estructuras/RNHAreaUpd";
import { RNHAreaGet } from "services/services-mia/programa-salud/estructuras/RNHAreaGet";

export default function UpdateModal({ updateList, row, closeModal, filtro }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const zonas = filtro;
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [inRequest, setInRequest] = useState(false);

    const getArticulosData = async () => {
        setIsLoading(true);
        // El filtro de RNHAreaGet es `rnhAreaCod`: `areaId` NO es un param del
        // servicio, asi que se ignoraba, el Get devolvia TODAS las areas y `result[0]`
        // era la primera de la lista en vez de la que se abrio.
        const { data: result } = await RNHAreaGet(credentials, { areaCod: row.cod })
        const area = result?.[0] ?? {};

        // La zona viaja por COD de punta a punta: asi la devuelve RNHAreaGet, asi la
        // guarda el select y asi la recibe RNHAreaUpd. Antes el select trabajaba con ids
        // y habia que traducir el cod contra el catalogo de zonas en cada apertura.
        //
        // La fila ya trae nombre, cod, wkt y version: sirven de respaldo si el Get
        // falla o si el back deja de mandar alguno.
        formikRef.current.setValues({
            id: area.rnhAreaId,
            nombre: area.rnhAreaNombre ?? row?.name ?? "",
            cod: area.rnhAreaCod ?? row?.cod ?? "",
            zonaCod: area.rnhZonaCod ?? row?.zonaCod ?? "",
            wkt: area.rnhAreaWKT ?? row?.wkt ?? "",
            version: area.rnhAreaVersion ?? row?.version,
        });
        setData(area);
        setIsLoading(false);
    }
    const handleUpdArea = async (values) => {
        const response = await RNHAreaUpd(credentials, {
            // OJO: RNHAreaUpd identifica por `rnhAreaId`, que sale del Get por cod.
            // Si el back deja de devolver el id en esa response, esto viaja vacio y el
            // Upd no tiene a que area aplicarle el cambio.
            id: data.rnhAreaId,
            cod: values.cod,
            name: values.nombre,
            version: data.rnhAreaVersion ?? values.version,
            zonaCod: values.zonaCod,
            wkt: values.wkt,
        })
        if (response.ok) {
            setSnackBarInfo({
                message: "Area modificada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        } else {
            setSnackBarInfo({
                message: response.error?.mensaje || "No se pudo modificar el área",
                severity: "error",
                open: true,
            });
        }
    };
    useEffect(() => {
        getArticulosData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                zonaCod: "",
                cod: "",
                wkt: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
                    zonaCod: yup.string("Debe seleccionar una zona").required("Debe ingresar una zona"),
                    cod: yup.string("Debe ingresar un Código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un Código"),
                })
            }
            onSubmit={(values) => {
                handleUpdArea(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={2}
                      sx={{
                        width: "100%",
                        "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                      }}
                    >
                      <Grid item xs={12}>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            labelText="Nombre"
                            inputProps={{ maxLength: LARGO.nombre }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            labelText="Código"
                            inputProps={{ maxLength: LARGO.cod }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormikSelectInput
                            fullWidth={true}
                            name="zonaCod"
                            labelText="Zona"
                            onChange={(e) => {
                                formikRef.current.setFieldValue("zonaCod", e.target.value);
                            }}
                        >
                            <option value="" selected disabled >Seleccione</option>
                            {zonas.map(({ rnhZonaCod, rnhZonaNombre }) => (
                                <option
                                    key={rnhZonaCod}
                                    value={rnhZonaCod}
                                >
                                    {rnhZonaNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                      </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
